import { connect } from 'react-redux';

import LoginPage from './LoginPage';
import { actionCreators } from '../../dux/user';

const mapDispatchToProps = {
  logInHandler: actionCreators.logIn,
};

export default connect(null, mapDispatchToProps)(LoginPage);
